import s from './MainButton.module.css'

export default function MainButton({text, href, style}: {text: string, href: string, style?: string}) {
    return (
        <a href={href} className={`${s.button} ${style ? s[style] : ''}`}>
          <svg className={s.buttonIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
            <path d="M10.9727 17.2222V17.2222C10.9727 13.2335 14.2062 10 18.1949 10L20.0004 10" stroke="white" strokeWidth="2" strokeLinejoin="bevel"/>
            <path d="M10.9727 2.77777V2.77777C10.9727 6.7665 14.2062 9.99999 18.1949 9.99999L20.0004 9.99999" stroke="white" strokeWidth="2" strokeLinejoin="bevel"/>
            <path d="M20 10L0 10" stroke="white" strokeWidth="2"/>
          </svg>
          {text}
        </a>
    )
}